// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__DOdt0","secondary":"Tabs_secondary__3ris3","primary":"Tabs_primary__-JEq-","tabItem":"Tabs_tabItem__HY6_2","hide":"Tabs_hide__7_CmA"};